$(document).ready(function () {
  $(".custHomeSec9 .pricing-card").each(function(){
    var price = $(this).find('.price');
    var subtext = $(this).find('.subtext');
    var button = $(this).find('a.button');
        var wrapper = $('<div class="custPriceBtm"></div>');  
        price.first().before(wrapper);
        wrapper.append(price);
        wrapper.append(subtext);
        wrapper.append(button);   
  });

  $('.custInstaPageSec9 .team-section .team-member').each(function () {
    var $teamMember = $(this);
    var $heading = $teamMember.find('.team-member-content h3');
    var $imageWrapper = $teamMember.find('.team-member-image');
  
    if ($heading.length && $imageWrapper.length) {
      $heading.appendTo($imageWrapper);
    }
  });
  
    

  const $checkbox = $('.custSwitchBtn input[type="checkbox"]');
  const $pricingCards = $('.pricing-cards');

  if($checkbox.is(':checked')){
    $pricingCards.addClass('active');
  }
  else{
    $pricingCards.removeClass('active');
  }

  
  $checkbox.on('change', function(){
    $pricingCards.toggleClass('active', $(this).is(':checked'));
  });


  $(".footer-group.footer-group  .footer__logo").appendTo('footer-group.footer-group .footer-copyright');



  $(".custHomeHeroSec .banner_box_main_left_btns a.button.btn-2").click(function(){
    $("#myModal").addClass("active");
  });
  $(".custHomeHeroSec  .close").click(function(){
    $("#myModal").removeClass("active");
  });

  setTimeout(function() {
      //$('.custInstaPageSec5 .faq .left-div .accordion:first-child details.details').attr('open', '');
  }, 300); 
  
  

  //$('.custInstaPageSec5 .faq .accordion:first-child details.details').attr('aria-expanded', 'true');  
  var $faq = $('.custInstaPageSec5 .faq');
  var $accordions = $faq.find('.accordion');
  var $leftDiv = $('<div class="left-div"></div>');
  var $rightDiv = $('<div class="right-div"></div>');
  $faq.prepend($leftDiv).append($rightDiv);
  /*$accordions.slice(0, 2).appendTo($leftDiv);
  $accordions.slice(2).appendTo($rightDiv);*/
  $accordions.slice(0, 4).appendTo($leftDiv);
  $accordions.slice(4, 8).appendTo($rightDiv);

  setTimeout(function(){
        /*
        const $details = $('.custInstaPageSec5 .faq .left-div .accordion:first-child details.details');
        const $summary = $details.find('summary');
      
        
        $summary.off('click');
      
       
        $summary.on('click', function (e) {
          e.preventDefault(); 
      
          if ($details.prop('open')) {
          
            $details.removeAttr('open');
          } else {
          
            $details.attr('open', '');
          }
        });
        */


    //$('.custInstaPageSec5 .faq .left-div .accordion:first-child details.details').attr('aria-expanded', 'true'); 
  }, 300);

  
  /*
  var InstaDv = $('.custNewAboutSecInsta .section-container .main-content .rich-text');
  var $custInstaLft = $('<div class="custInstaLft"></div>');
  var $custInstaRt = $('<div class="custInstaRt"></div>');
  InstaDv.prepend($custInstaLft).append($custInstaRt);
  
  var abtDesc = $('.custNewAboutSecInsta .section-container .main-content .rte');
  var abtImg = $('.custNewAboutSecInsta .section-container .main-content .leading-none');
  abtDesc.appendTo($custInstaLft);
  abtImg.appendTo($custInstaRt);
  
  var checkHeading = setInterval(function () {
    var abtHdng = $('.custNewAboutSecInsta .section-container .main-content h2.heading');
    if (abtHdng.length && $.contains(document, abtHdng[0])) {
      abtHdng.appendTo($custInstaLft);
      clearInterval(checkHeading); 
    }
  }, 100);
  */
  $('.custNewAboutSecInsta .section-container .main-content .rich-text').each(function () {
    var $instaDv = $(this);
    var $custInstaLft = $('<div class="custInstaLft"></div>');
    var $custInstaRt = $('<div class="custInstaRt"></div>');
  
    $instaDv.prepend($custInstaLft).append($custInstaRt);
  
    var $mainContent = $instaDv.closest('.main-content');
  
    var $abtDesc = $mainContent.find('.rte');
    var $abtImg = $mainContent.find('.leading-none');
  
    $abtDesc.appendTo($custInstaLft);
    $abtImg.appendTo($custInstaRt);
  
    // Heading move inside this section only
    var checkHeading = setInterval(function () {
      var $abtHdng = $mainContent.find('h2.heading');
      if ($abtHdng.length && $.contains(document, $abtHdng[0])) {
        $abtHdng.appendTo($custInstaLft);
        clearInterval(checkHeading);
      }
    }, 100);
  });


  var faqCtctBtn = $('.custContactFaqs .title-wrapper p');
  var faqCtctFaqs = $('.custContactFaqs .faqs');
  faqCtctBtn.appendTo(faqCtctFaqs);


  $('.custBlogPageSec2 .blogs-categories-search-row .row-blogs-categories .custBlgCatSelectTtl').click(function(){
    $(this).parent('.custBlgCatSelectMn').toggleClass('active');
  });


$('.team-main-wrap .team-section').on('click', '.goto-detail', function (e) {
      e.preventDefault(); 
      var $clickedMember = $(this).closest('.team-member');
      if ($clickedMember.hasClass('isactive')) {
        $clickedMember.removeClass('isactive');
      } else {
        $('.team-main-wrap .team-section .team-member').removeClass('isactive');
        $clickedMember.addClass('isactive');
      }
    });
  
});

$(document).ready(function () {
    var $sections = $('.custMembershipPageExpertLedSec');

    $sections.each(function (index) {
      if (index < 2) {
        var $section = $(this);
        var $heading = $section.find('h2.heading.leading-none.title-lg.tracking-heading');
        var $nextDiv = $heading.next('.leading-none');

        if ($heading.length && $nextDiv.length) {
          var $wrapper = $('<div class="outer-image-text1"></div>');

          $heading.before($wrapper);
          $wrapper.append($heading);
          $wrapper.append($nextDiv);
        }
      }
    });
	
	
  });
  
  $(document).ready(function () {
    var $buttons = $('.custMembershipPageCourseIncSMCProHead .button');

    if ($buttons.length >= 2) {
      $buttons.eq(0).addClass('faq-button1');
      $buttons.eq(1).addClass('faq-button2');
    }
  });

 $(document).ready(function () {
  $('.faq-button1').addClass('active');
  $('.faq-first').addClass('active');
  $('.faq-button1').on('click', function (e) {
    e.preventDefault();
    $('.faq-button1, .faq-button2').removeClass('active');
    $('.faq-first, .faq-second').removeClass('active');
    $(this).addClass('active');
    $('.faq-first').addClass('active');
  });
  $('.faq-button2').on('click', function (e) {
    e.preventDefault();
    $('.faq-button1, .faq-button2').removeClass('active');
    $('.faq-first, .faq-second').removeClass('active');
    $(this).addClass('active');
    $('.faq-second').addClass('active');
  });
});

$(document).ready(function () {
  $('.custMembershipPagefaqSec .accordion summary a').on('click', function (e) {
    e.stopPropagation(); 
  });
});
